<template>
  <template v-if="dataInfoArray">
    <div class="tw-flex tw-gap-3">
      <!-- Delete sections -->
      <template v-for="(data, index) in dataInfoArray" :key="index">
        <template v-if="data.type === 'recipients'">
          <div class="tw-flex tw-flex-col tw-gap-2">
            <p class="tw-m-0 tw-text-lg tw-text-warning-500">
              Please choose the lifecycle stage you'd like your selected
              recipients to move to.
            </p>
            <select
              v-model="lifecycleStageSelection"
              id="lifecycleStageSelection"
              name="lifecycleStageSelection"
              :class="{ 'tw-ring-red-300': !lifecycleStageSelection }"
              class="tw-block tw-bg-white tw-w-full tw-rounded-md tw-border-0 tw-px-4 tw-py-4 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-blue-600 tw-text-lg sm:tw-leading-6"
            >
              <option value="" class="" disabled>Select lifecycle stage</option>
              <option
                v-for="option in lifecycleOptions"
                :value="option.value"
                :key="option.index"
                class=""
              >
                {{ option.text }}
              </option>
            </select>
            <div class="tw-flex tw-gap-2">
              <TheButton :disabled="!lifecycleStageSelection" variant="primary" size="large" @click="confirm()">
                <template #text>Save</template>
              </TheButton>
              <TheButton variant="tertiary" size="large" @click="cancel()">
                <template #text>Cancel</template>
              </TheButton>
            </div>
          </div>
          <div
            class="tw-w-full tw-bg-gray-50 tw-border-solid tw-border tw-rounded-lg"
          >
            <ul class="tw-list-none tw-h-full tw-p-4 tw-m-0">
              <li class="tw-h-full">
                <div
                  class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-2 tw-h-full"
                >
                  <p class="tw-text-3xl tw-m-0 tw-font-bold">
                    {{ data.data.length }}
                  </p>
                  <p class="tw-text-xl tw-m-0">
                    {{ data.type }} will be edited
                  </p>
                </div>
              </li>
              <!-- </template> -->
            </ul>
          </div>
        </template>
      </template>
    </div>
  </template>
</template>

<script>
import TheButton from "../actions/TheButton.vue";

export default {
  name: "BulkEditData",
  emits: ["confirmBulkEdit"],
  components: {
    TheButton,
  },
  props: {
    orders: {
      type: Array,
      required: false,
    },
    products: {
      type: Array,
      required: false,
    },
    kits: {
      type: Array,
      required: false,
    },
    proposals: {
      type: Array,
      required: false,
    },
    vendors: {
      type: Array,
      required: false,
    },
    shippingMethods: {
      type: Array,
      required: false,
    },
    packagingOptions: {
      type: Array,
      required: false,
    },
    members: {
      type: Array,
      required: false,
    },
    campaigns: {
      type: Array,
      required: false,
    },
    recipients: {
      type: Array,
      required: false,
    },
    media: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      lifecycleStageSelection: "",
      lifecycleStages: [
        "Center of Influence",
        "Customer",
        "Warm Lead",
        "Cold Lead",
      ],
    };
  },
  computed: {
    dataInfoArray() {
      const dataTypes = [
        { type: "campaigns", data: this.campaigns },
        { type: "vendors", data: this.vendors },
        { type: "members", data: this.members },
        { type: "recipients", data: this.recipients },
        { type: "media", data: this.media },
      ];

      return dataTypes.filter((dataInfo) => dataInfo.data);
    },
    lifecycleOptions() {
      const options = this.lifecycleStages.map((tag) => ({
        text: tag,
        value: tag,
      }));
      return options;
    },
  },
  methods: {
    confirm() {
      this.$emit("confirmBulkEdit", this.lifecycleStageSelection);
    },
    cancel() {
      this.$emit("closeModal");
    },
  },
};
</script>

<style scoped>
select {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e");
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
  -webkit-appearance: none;
  appearance: none;
}
</style>
